function LoadingRoute() {
  return <div className="text-center mt-40 fixed top-0 left-0 w-full h-screen"><div className="flex items-center justify-center">Loading ...</div></div>;
}

export default LoadingRoute;
